import WRAP from "WRAP-JS";

const ADDITIONAL_STYLE = [
	[WRAP.Geo.Feature.GeoLine, ["line_dash"]],
]

const superRenderer = WRAP.Renderer;
/* eslint-disable */
WRAP.Renderer = Object.assign(function () {
	const renderer = this;
	superRenderer.call(this);

	function toCamel(str) {
		// Safariが後読み正規表現をサポートしておらずiPad等で開くとエラーになるため、後読みを使わないように修正
		// return str.split(/(?<=[a-z])_(?=[a-z])/)
		return str.split(/_/)
			.map((w, i) => i === 0 ? w : w.charAt(0).toUpperCase() + w.slice(1))
			.join('');
	}

	const superDrawFeature = renderer.drawFeature;
	renderer.drawFeature = function (layer, geo, prop, style, data) {
		superDrawFeature.call(this, layer, geo, prop, style, data);
		const feature = layer._dl.slice(-1)[0];
		for (const [clazz, words] of ADDITIONAL_STYLE) {
			if (feature instanceof clazz) {
				words.forEach(v => {
					if (v in style) {
						const s = feature.style();
						s[toCamel(v)] = style[v];
					}
				})
			}
		}
	}
}, superRenderer);
/* eslint-enable */
